<div class="withdraw-reasons" [formGroup]="parent">
  <h2 class="ds-heading-2">{{ 'ACCOUNT.withdrawalV2.reason.heading' | translate }}</h2>
  <app-ds-checkbox
    *ngFor="let option of reasonOptions; let i = index"
    (clicked)="onCheckboxChange(option.id, option.option_text)"
    [checked]="isSelected(option.id)"
    [label]="option.option_text"
  ></app-ds-checkbox>
</div>

<div class="withdraw-buttons" [class.mobile-buttons]="isMobileApp" [ngStyle]="{ display: isMobileApp ? 'block' : 'flex' }">
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'" [disabled]="parent.invalid" (clicked)="onContinue()">{{
    'ACCOUNT.withdrawalV2.buttons.next' | translate
  }}</app-ds-button>
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'" variant="outline" (clicked)="onBack()">{{
    'ACCOUNT.withdrawalV2.buttons.previous' | translate
  }}</app-ds-button>
</div>
